import React from 'react';
import Icon from '@ant-design/icons';
import { ButtonType, Button } from 'components/Controls/Button';
import { SizeType } from 'antd/lib/config-provider/SizeContext';
import ArrowExpandDownSvg from './arrowExpandDown.svg';

type IconButtonProps = {
  size?: SizeType,
  iconSize?: number,
  onClick?: () => void,
};

export const ArrowExpandDownIcon = (props: any) => <Icon component={ArrowExpandDownSvg} {...props} />;

export const ArrowExpandDownButton = ({ size = 'medium', iconSize = 24, ...props }: IconButtonProps) => (
  <Button
    type={ButtonType.OutlineIcon}
    icon={<ArrowExpandDownIcon width={iconSize} height={iconSize} />}
    size={size}
    {...props}
  />
);
